import { render, staticRenderFns } from "./DownloadCsv.vue?vue&type=template&id=ab0fac4a&"
import script from "./DownloadCsv.vue?vue&type=script&lang=js&"
export * from "./DownloadCsv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports